<template>
  <!-- 剧集抽屉 -->
  <a-drawer
    :title="id ? '编辑' : '新增'"
    width="700"
    :closable="false"
    :visible="visible"
    @close="onClose"
    :footer-style="{ textAlign: 'right' }"
  >
    <!-- 表单数据 -->
    <a-form
      name="form"
      ref="RefForm"
      :model="formState"
      :label-col="{ span: 5 }"
      :wrapper-col="{ span: 17 }"
    >
      <!-- 名称 -->
      <a-form-item
        label="名称"
        name="name"
        :rules="[{ required: true, message: '请输入' }]"
      >
        <a-input v-model:value="formState.name" placeholder="请输入" />
      </a-form-item>
      <!-- 公司主体 -->
      <a-form-item
        name="company_name"
        :rules="[{ required: true, message: '请输入' }]"
      >
        <template #label>
          公司主体
          <a-tooltip>
            <template #title>需跟合同签约的公司主体名称一致</template>
            <info-circle-outlined style="padding: 0 4px;" />
          </a-tooltip>
        </template>
        <a-input v-model:value="formState.company_name" placeholder="请输入" />
      </a-form-item>
      <!-- IAP分成比例 -->
      <a-form-item
        name="iap_rate"
        :rules="[{ required: true, message: '请输入' }]"
      >
        <template #label>
          IAP分成比例
          <a-tooltip>
            <template #title>按充值金额进行比例分成。修改分成比例只对修改后的数据生效。</template>
            <info-circle-outlined style="padding: 0 4px;" />
          </a-tooltip>
        </template>
        <a-input v-model:value="formState.iap_rate" placeholder="请输入" suffix="%" />
      </a-form-item>
    </a-form>
    <!-- 尾部 -->
    <template #footer>
      <a-button style="margin-right: 8px" @click="onClose">取消</a-button>
      <a-button type="primary" @click="touchSubmit">确定</a-button>
    </template>
    <!-- 加载 -->
    <Loading :loading="isLoading"></Loading>
  </a-drawer>
</template>

<script setup>
import { ref, reactive, defineExpose, nextTick } from 'vue'
import { message } from 'ant-design-vue'
import { supplierSave } from '@/api/request'
import Loading from '@/components/Loading'

// 回调
const emit = defineEmits('success')
// 表单实例
let RefForm = ref(null)
// 是否展示弹窗
let visible = ref(false)
// id
let id = ref(null)
// 表单数据
let formState = reactive({
  // 名称
  name: undefined,
  // 公司主体
  company_name: undefined,
  // IAP分成比例
  iap_rate: undefined
})
// 加载
let isLoading = ref(false)

// 打开抽屉
function showDrawer (params) {
  // 展开
  visible.value = true
  // id
  id.value = params.id
  // 赋值
  nextTick(() => {
    if (params.id) {
      formState.name = params.name
      formState.company_name = params.company_name
      formState.iap_rate = params.iap_rate
    }
  })
}

// 关闭弹窗
function onClose () {
  // 重置表单
  RefForm.value.resetFields()
  visible.value = false
}

// 提交
function touchSubmit () {
  // 手动触发表单验证
  RefForm.value.validate()
  .then(() => {
    isLoading.value = true
    supplierSave({
      id: id.value,
      ...formState
    }).then(res => {
      isLoading.value = false
      const { code, msg, data } = res
      if (code === 0) {
        message.success('操作成功')
        // 更新父组件
        emit('success')
        // 关闭弹窗
        onClose()
      } else {
        message.error(res.message || msg)
      }
    })
  })
}

defineExpose({
  showDrawer
})

</script>

<style lang="less" scoped>

</style>